import { render, staticRenderFns } from "./aiGenerateKnowledgeCreate.vue?vue&type=template&id=6b44d120&scoped=true"
import script from "./aiGenerateKnowledgeCreate.vue?vue&type=script&lang=js"
export * from "./aiGenerateKnowledgeCreate.vue?vue&type=script&lang=js"
import style0 from "./aiGenerateKnowledgeCreate.vue?vue&type=style&index=0&id=6b44d120&prod&scoped=true&lang=css"
import style1 from "./aiGenerateKnowledgeCreate.vue?vue&type=style&index=1&id=6b44d120&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b44d120",
  null
  
)

export default component.exports